import React, { useEffect } from 'react';
import { Box, Typography, Grid, CircularProgress, Alert, Divider, Card, CardContent } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
import { useSnackbar } from 'notistack';
import { Groups, LocationCity, Email, Phone, CalendarToday, Star } from '@mui/icons-material';
// import { getClubProfile, saveClubProfile } from 'apis/controllers/club'; // you must implement
import ClubProfileForm from './ClubProfileForm';
import { getAgreements } from 'apis/controllers/generic';

const ClubProfile = () => {
    const { id } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const queryClient = useQueryClient();

    const agreementsQuery = useQuery(
        ['agreements', id],
        async () => {
            const res = await getAgreements({
                DataKey: 'Organization',
                RecordGuid: id
            });

            return res?.data;
        },
        { enabled: true }
    ); // Only fetch when editing);

    const { data, isLoading, isError, refetch } = useQuery(
        ['clubProfile', id],
        async () => {
            const res = { data: 'helllo' }; // getClubProfile({ Id: id });
            return res?.data;
        },
        {
            enabled: !!id
        }
    );

    const handleSubmit = async (formData) => {
        try {
            const res = await console.log(formData); //saveClubProfile({ ...formData, Id: clubId });
            if (res?.status === 'success') {
                enqueueSnackbar('Club profile saved!', { variant: 'success' });
                queryClient.invalidateQueries(['clubProfile', clubId]);
                refetch();
            } else {
                enqueueSnackbar(res?.message || 'Something went wrong.', { variant: 'error' });
            }
        } catch (e) {
            console.error(e);
            enqueueSnackbar('Server error. Try again later.', { variant: 'error' });
        }
    };

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (isError || !data) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                <Alert severity="error">Error loading club profile.</Alert>
            </Box>
        );
    }

    return (
        <ClubProfileForm
            mode={id ? 'edit' : 'create'}
            clubQuery={{ data, isLoading, isError, refetch }}
            agreementsQuery={agreementsQuery}
        />
    );
};

export default ClubProfile;
